/*@flow*/
import L from 'leaflet';
import isSmallScreen from 'lib/isSmallScreen';
import type { DeckPropsT } from '../types';
import { useEffect, useState } from 'react';
import useLayer from '../useLayer';
import {
  defaultPopUpOptions,
  type PopupOptionsT,
  type WithPopup,
} from './Popup';

export const defaultOptions = {
  color: 'white',
  weight: 2,
  opacity: 1,
  fillOpacity: 1,
  fillColor: 'orange',
  popupOptions: defaultPopUpOptions,
  interactive: true,
  radius: 10,
};

type OptionsT = {|
  latlon: number[] | Leaflet$LatLng,
  opacity?: number,
  fillOpacity?: number,
  weight?: number,
  radius?: number,
  color?: string,
  fillColor?: string,
  popupOptions?: PopupOptionsT,
|};

type CircleMarkerWithPopupT = WithPopup<Leaflet$CircleMarker>;

function CircleMarker(props: DeckPropsT<OptionsT>) {
  const [element, setElement] = useState();
  const { options } = props;

  useEffect(() => {
    let opts = { ...defaultOptions, ...options };
    if (isSmallScreen()) {
      opts = { ...opts, radius: 10 };
    }
    const { latlon, ...rest } = opts;

    let el: CircleMarkerWithPopupT = L.circleMarker(latlon, rest);

    // Create popup
    if (opts.popupOptions.enabled) {
      const popOpts = { ...defaultPopUpOptions, ...opts.popupOptions };
      const html = "<div class='pop-component'></div>";
      el.bindPopup(html, popOpts);
    }
    setElement(() => el);

    return () => {
      el.closePopup();
      el.unbindPopup();
    };
  }, []);

  useLayer<OptionsT>(props, element);

  useEffect(() => {
    if (!element) return;
    let { latlon } = options;
    latlon && element.setLatLng(latlon);
  }, [options, element]);
}

export default CircleMarker;
